import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '../components/AuthLayout';
import { ForgotPasswordForm } from '../components/forms/ForgotPasswordForm';

export const ForgotPasswordPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <AuthLayout
      title={t('auth.forgotPassword.title')}
      subtitle={t('auth.forgotPassword.subtitle')}
    >
      <ForgotPasswordForm />
    </AuthLayout>
  );
};
